import {
  createSimpleFunctional
} from '~util/helpers'

import VDataTable from './VDataTable'
import VEditDialog from './VEditDialog'
export const VTableOverflow = createSimpleFunctional('table__overflow')

export default {
  VDataTable,
  VEditDialog,
  VTableOverflow
}



// WEBPACK FOOTER //
// ./src/components/tables/index.js